<template>
  <md-dialog :md-active.sync="showDialog">
    <div class="dialog-content">
      <h1>Geschafft!</h1>
      <p class="md-body-1">
        Herzlichen Glückwunsch! Du hast die Theorieprüfung erfolgreich
        bestanden. Erstelle dir jetzt dein Zertifikat und lege es beim
        Praxislehrgang deinem Ausbilder vor.
      </p>
      <form @submit="formHandler">
        <md-field>
          <label for="name"> Name:</label>
          <md-input
            type="text"
            id="name"
            name="name"
            autocomplete="name"
            placeholder="Vor- und Nachname"
            v-model.trim="$v.name.$model"
          />
          <span class="error" v-if="$v.name.$error">Bitte Name eingeben</span>
        </md-field>
        <md-datepicker
          v-model.trim="$v.birthday.$model"
          md-immediately
          :md-model-type="String"
        >
          <label>Geburtstag</label>
          <span class="error" v-if="$v.birthday.$error"
            >Bitte Geburtsdatum eingeben</span
          >
        </md-datepicker>
        <md-field>
          <label for="name"> E-Mail:</label>
          <md-input
            type="email"
            name="email"
            autocomplete="email"
            placeholder="some@domain.tld"
            v-model.trim="$v.email.$model"
          />
          <span class="error" v-if="$v.email.$error"
            >Bitte E-Mail eingeben</span
          >
        </md-field>
        <md-button class="md-raised md-primary" type="submit"
          >Zertifikat erstellen</md-button
        >
      </form>
    </div>
  </md-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    identifier: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    formHandler: function (event) {
      event.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.$store.dispatch(`${this.identifier}/generateCertificate`, {
        questionnaire: this.identifier,
        name: this.name,
        birthday: this.birthday,
        email: this.email,
        dt: new Date().toISOString(),
      });
      this.trail({
        type: "questionnaire-certified",
        questionnaire: this.identifier,
      });
      this.$router.push(`/${this.identifier}/certificate`);
    },
  },
  data: () => ({
    name: "",
    birthday: null,
    email: "",
  }),
  validations: {
    name: { required },
    birthday: { required },
    email: { required },
  },
};
</script>
<style scoped>
.dialog-content {
  padding: 2%;
}
.error {
  position: absolute;
  bottom: -22px;
  color: red;
}
</style>
